import './About.css';

const STRENGTHS = [
  { icon: 'ti-layout-2',    title: 'Full-stack ownership',   desc: 'API design to Angular UI — end to end, no handoffs' },
  { icon: 'ti-cloud',       title: 'Azure cloud fluency',    desc: 'Data Factory, Service Bus, Logic Apps, API Management' },
  { icon: 'ti-robot',       title: 'AI-assisted dev',        desc: 'Cursor IDE, Cursor Rules, MCP & vibe coding workflows' },
  { icon: 'ti-users',       title: 'Agile team lead',        desc: 'Sprint planning, backlog refinement, cross-team delivery' },
  { icon: 'ti-arrows-transfer-up', title: 'Framework migrations', desc: 'Angular 14→17, .NET 6→8 with zero production regression' },
  { icon: 'ti-components',  title: 'Reusable architecture',  desc: 'Component libraries, dynamic forms, design systems' },
];

const STATS = [
  { num: '8+',  label: 'Years of experience', desc: 'Enterprise web across 4 industry verticals' },
  { num: '6',   label: 'Major projects',       desc: 'Healthcare · Workforce · Aviation · Manufacturing' },
  // { num: '4',   label: 'UK & SE Asia clients', desc: 'Indigo, Asolva, Malindo Air, Bangkok Air' },
  // { num: '15+', label: 'Technologies',         desc: '.NET · Angular · Azure · Supabase · MCP & more' },
];

const AWARDS = [
  { title: 'Best Budding Star',  org: 'GoQuo (TWAI)' },
  { title: 'Living Our Values',  org: 'Optisol Business Solutions' },
  { title: 'Claude Certified Developer – Foundations', org: 'Anthropic · CCDV-F', icon: 'ti-certificate', url: 'https://www.credly.com/badges/9e3017f6-2afd-4772-b05e-22130be8f625/public_url' },
];

export default function About() {
  return (
    <section id="about" className="section-wrap">
      <div className="eyebrow-row">
        <div className="eyebrow-line" /><div className="eyebrow-txt">About me</div><div className="eyebrow-line" />
      </div>

      <div className="about-grid">
        <div className="about-left">
          <div className="avatar">
            <div className="avatar-ring" />
            <div className="avatar-monogram">VR</div>
            <div className="avatar-sub">Vikram Raja</div>
          </div>
          <div className="upload-hint">Photo coming soon</div>
          <div className="contact-pills">
            {[
              { icon: 'ti-map-pin', val: 'Madurai, India' },
              { icon: 'ti-mail',    val: 'vikramrajavc@gmail.com' },
              { icon: 'ti-phone',   val: '+91 87606 36511' },
              { icon: 'ti-briefcase', val: 'Open to remote' },
            ].map(c => (
              <div key={c.val} className="cpill">
                <i className={`ti ${c.icon}`} /><span>{c.val}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="about-right">
          <p className="about-intro">
            Senior Full-Stack Developer with <strong>8+ years</strong> of experience crafting enterprise-grade web applications across <strong>healthcare, workforce, aviation</strong> and <strong>manufacturing</strong> industries. I work across the full stack — from <strong>ASP.NET Core APIs</strong> and <strong>Angular SPAs</strong> to <strong>Azure CI/CD pipelines</strong> — and currently lead AI-assisted development workflows using <strong>Cursor IDE</strong> and <strong>MCP</strong>.
          </p>

          <div className="stats-grid">
            {STATS.map(s => (
              <div key={s.label} className="card stat-card">
                <div className="stat-num">{s.num}</div>
                <div className="stat-lbl">{s.label}</div>
                <div className="stat-desc">{s.desc}</div>
              </div>
            ))}
          </div>

          <div className="strengths-title">Key strengths</div>
          <div className="strengths-grid">
            {STRENGTHS.map(s => (
              <div key={s.title} className="card strength-card">
                <i className={`ti ${s.icon} str-icon`} />
                <div>
                  <div className="str-title">{s.title}</div>
                  <div className="str-desc">{s.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="awards-row">
            {AWARDS.map(a => {
              const Tag = a.url ? 'a' : 'div';
              const linkProps = a.url ? { href: a.url, target: '_blank', rel: 'noopener noreferrer', title: 'Verify on Credly' } : {};
              return (
                <Tag key={a.title} className={`award-card ${a.url ? 'award-link' : ''}`} {...linkProps}>
                  <i className={`ti ${a.icon || 'ti-award'} award-icon`} />
                  <div>
                    <div className="award-title">{a.title}</div>
                    <div className="award-org">{a.org}</div>
                  </div>
                  {a.url && <i className="ti ti-external-link award-ext" />}
                </Tag>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
